
<template>
    <div v-if="type" id="picker">
        <div @click="visible = true">
            <slot name="selected" :data="values[type]"> </slot>
        </div>
        <Popup v-model="visible" position="bottom">
            <Picker
                :show-toolbar="true"
                :title="config[type].title"
                :columns="['请选择', ...config[type].list]"
                :defaultIndex="index"
                @confirm="handleConfirm"
                @cancel="hide"
                :value="values[type]"
            />
        </Popup>
    </div>
</template>

<script>
// components
import { Picker, Popup } from "vant";
import config from "./config";

export default {
    props: {
        values: {
            type: Object,
            default: function () {
                return {};
            },
        },
    },
    components: {
        Picker,
        Popup,
    },
    watch: {
        visible: {
            handler: function(val) {
                if(val) {
                    const index = this.config[this.type].list.findIndex((item) => {
                        return item.text === this.values[this.type].text
                    })
                    this.index = index >= 0 ? index + 1 : index
                }
            },
            deep: true
        }
    },
    data() {
        return {
            type: "",
            visible: false,
            config,
        };
    },
    methods: {
        show(type, config) {
            console.log(config)
            this.visible = true;
            this.type = type;
            if (config) {
                this.config[this.type].list = config
            }
        },
        hide() {
            this.type = "";
            this.visible = false;
        },
        handleConfirm(value) {
            this.$emit('confirm', value, this.type)
            this.hide();
        },
    },
};
</script>